var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './styles.module.scss';
export var Card = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.padding, padding = _b === void 0 ? 1 : _b, _c = _a.radius, radius = _c === void 0 ? 'none' : _c, _d = _a.borderWidth, borderWidth = _d === void 0 ? 0 : _d, rest = __rest(_a, ["children", "className", "padding", "radius", "borderWidth"]);
    var passedStyle = rest.style, restProps = __rest(rest, ["style"]);
    var cardStyle = __assign({ padding: "var(--Spacing-".concat(padding, ")"), borderRadius: "var(--Radius-".concat(radius, ")"), borderWidth: borderWidth }, (passedStyle || {}));
    return (_jsx("div", __assign({ className: classNames(styles.card, className), style: cardStyle }, restProps, { children: children })));
};
